import React, { Component } from 'react';
import { Container, Heading } from '@wienenergiegithub/ui-next';

/**
 * ErrorBoundary component has to be written as a class component
 * because `getDerivedStateFromError` and `componentDidCatch`
 * lifecycle methods have no hook equivalent yet.
 * Reference: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 */
class ErrorBoundary extends Component {
  // Updates state if error has been detected in any child component
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);

    // Define a state variable to track if there is an error.
    this.state = { hasError: false };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { hasError } = this.state;

    return nextState.hasError !== hasError;
  }

  // Logs any error that has been detected in any child component
  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.log({ error, errorInfo });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    return hasError ? (
      <Container>
        <Heading size="h2">Der Inhalt ist leider nicht verfügbar.</Heading>
      </Container>
    ) : (
      children
    );
  }
}

export default ErrorBoundary;
